import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/ui/Button";

export default function Locked() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="bg-white border border-slate-200 rounded-2xl p-8 text-center max-w-md w-full shadow-sm">
        <div className="text-3xl font-semibold text-slate-900">Access Denied</div>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          This page is restricted. You don’t have permission to access the admin panel.
        </p>

        <div className="mt-6">
          <Link to="/">
            <Button className="w-full">Back Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
